import { useParams } from "react-router-dom";
import { useLocales } from "../../hooks";
import { useState } from "react";
import { isExists, params } from "../../utils";
import { useGetListQuery } from "../../features/api/Api";
import { GridColDef } from "@mui/x-data-grid";
import {
  CustomDateField,
  List,
  ListRefPreviewButton,
  MetaTags,
  MuiDatagrid,
} from "../../components";

const DocumentList = () => {
  const { translate } = useLocales();
  const tableName = "Fesih Talebi ";
  const title = `${tableName}`;
  const { customerId } = useParams();

  const [documentParams, setDocumentParams] = useState({
    resource: `fixity/customer/document/get-list-by-customer-id`,
    params: { ...params, filter: { customerId: customerId, isDeleted: false } },
  });

  const { data: documents, isFetching: isLoading } =
    useGetListQuery<any>(documentParams);

  const columns: GridColDef[] = [
    {
      field: "description",
      headerName: translate("resources.customers.documents.description"),
      flex: 1,
    },
    {
      field: "creationTime",
      headerName: translate("resources.customers.documents.creation_time"),
      flex: 1,
      renderCell: ({ value }) => <CustomDateField data={value} />,
    },
    {
      field: translate("actions.edit"),
      headerName: "",
      disableColumnMenu: true,
      disableReorder: true,
      filterable: false,
      hideSortIcons: true,
      sortable: false,
      align: "center",
      width: 50,
      renderCell: (params) => (
        <>
          <ListRefPreviewButton
            id={
              params.row.merlinDocumentId
                ? params.row.merlinDocumentId
                : params.row.documentId
            }
          />
        </>
      ),
    },
  ];

  return (
    <>
      <MetaTags title={title} keyword={title} description={title} />
      <List tableName={tableName} loading={isLoading}>
        <MuiDatagrid
          loading={isLoading}
          rows={isExists(documents?.data) ? documents.data : []}
          columns={columns}
          rowCount={documents?.totalItemCount}
          pageSize={documentParams.params.pagination.size}
          pageNumber={documentParams.params.pagination.pageNumber}
          setPagination={setDocumentParams}
          autoHeight
        />
      </List>
    </>
  );
};

export default DocumentList;
